import React from "react";
import { RiTrophyLine, RiFireLine, RiFlagLine, RiFlashlightLine } from "react-icons/ri";

const ICONS = {
  pr: RiTrophyLine,
  streak: RiFireLine,
  milestone: RiFlagLine,
  volume: RiTrophyLine,
  duration: RiFlashlightLine,
};

const PostAchievements = ({ achievements }) => {
  if (!achievements?.length) return null;
  return (
    <div className="wpc-achievements">
      {achievements.map((a, i) => {
        const Icon = ICONS[a.type] || RiTrophyLine;
        return (
          <span className="wpc-achievement" key={i}>
            <Icon size={13} />
            {a.label}
          </span>
        );
      })}
    </div>
  );
};

export default PostAchievements;
